import type { Prefab } from "../prefab";
import { buildPrefab, buildPrefabWithOverrides } from "./prefabBuilder";
import { finalBranchStairData, fortressData, robotBaseEntranceData } from "./otherPrefabData";

export function getRobotBaseEntrancePrefab(destinationLevel: number): Prefab {
	return buildPrefabWithOverrides(robotBaseEntranceData, {
		D: { class: "Downstairs", props: { destination: destinationLevel } },
	});
}

export function getFinalBranchStairPrefab(destinationLevel: number): Prefab {
	return buildPrefabWithOverrides(finalBranchStairData, {
		D: { class: "Downstairs", props: { destination: destinationLevel } },
	});
}

export function getFortressPrefab(): Prefab {
	return buildPrefab(fortressData);
}
